<template>
  <DashboardVideo />
  <div
    class="container h-100 d-flex align-items-unset justify-content-center z-2"
  >
    <div class="row mobile align-content-unset g-0">
      <div
        class="col-12 ps-3 pe-3 d-flex align-items-center justify-content-end theme-header"
      >
        <a
          href="https://tool.metaluxe.com.au/"
          target="_blank"
          class="annotation"
          data-bs-toggle="tooltip"
          title="Click to Edits"
        >
          <img src="/img/ui-theme/annotation-red.svg"
        /></a>

        <a href="#" class="m-auto"
          ><img :src="`/img/ui-theme/` + theme.devLogo" class="devlogo"
        /></a>
        <button
          class="btn"
          type="button"
          data-bs-toggle="offcanvas"
          data-bs-target="#offcanvasRight"
          aria-controls="offcanvasRight"
          style="padding-right: 0; padding-left: 0"
        >
          <img src="/img/ui-theme/contact-icon-rev.svg" alt="Fullscreen" />
        </button>
      </div>
      <div class="col-12 d-flex align-items-unset justify-content-center z-2">
        <div class="row g-0">
          <div class="col-12">
            <!-- <router-link
              v-if="assetTypes && assetTypes.length > 0"
              :to="{
                name: 'VideoView',
                params: {
                  guid: '4709e682-1955-4b0f-980e-03883ab7f070',
                  collectionId: '503363',
                },
              }"
              class="border-top-right-radius btn-theme-menu mb-2"
            >
              <span className="video-label">Cinematic</span>
            </router-link> -->
            <div
              v-for="(assetType, key) in (assetTypes || []).filter(
                (item) => item.ObjectName !== 'Video'
              )"
              :key="assetType.Guid"
            >
              <router-link
                v-if="assetType.ObjectName === 'Renders'"
                :to="{
                  name: 'AssetView',
                  params: {
                    assetType: 'type1',
                    viewType: assetType.LinkName,
                  },
                }"
                :class="[
                  key === 0 ? 'border-top-right-radius' : '',
                  'btn-theme-menu',
                  'mb-2',
                ]"
              >
                <span className="video-label">{{ assetType.ObjectName }}</span>
              </router-link>

              <router-link
                v-if="assetType.ObjectName === '360 Tour'"
                :to="{
                  name: 'AssetViewDetail',
                  params: {
                    assetType: 'Rana',
                    viewType: '360-tour',
                    order: 0,
                  },
                }"
                :class="[
                  key === 1 ? 'border-bottom-left-radius ' : '',
                  'btn-theme-menu',
                  'mb-2',
                ]"
              >
                <span className="video-label">360 Tour</span>
              </router-link>
            </div>

            <!-- <router-link
              :to="{
                name: 'AssetViewDetail',
                params: {
                  assetType: 'Rana',
                  viewType: 'balcony-views',
                  order: 0,
                },
              }"
              class="btn-theme-menu mb-2 border-bottom-left-radius"
            >
              <img
                :src="theme.panoramasIcon"
                alt="virtual-tour"
                class="me-3 ms-4 video-icon"
              />
              <span className="video-label">Balcony Views</span>
            </router-link> -->
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- <OffCanvas /> -->
</template>

<script>
import DashboardVideo from '@/components/DashboardVideo.vue'
import OffCanvas from '@/components/OffCanvas.vue'
import global from '../global'
import BunnyNetService from '@/services/BunnyNetService.js'
import { unslugify } from 'unslugify'
import sortArray from 'sort-array'

export default {
  name: 'DashboardHome',
  components: {
    DashboardVideo,
    OffCanvas,
  },
  data() {
    return {
      assetTypes: null,
      componentName: 'AssetType',
      componentAdmin: 'Admin',
      folderStructure: encodeURIComponent(
        this.theme.devFolder + '/assets/' + 'type1' + '/'
      ),
      brochureUrl: '',
    }
  },
  created() {
    console.log(this.folderStructure)
    console.log('00000')
    BunnyNetService.getFolders(this.folderStructure)
      .then((response) => {
        // Remap array
        console.log(response.data)
        const menuItems = response.data.map((item) => {
          return {
            Guid: item.Guid,
            ObjectName: unslugify(item.ObjectName),
            LinkName: item.ObjectName,
            ComponentName: this.componentName,
            Path: item.Path,
            IsDirectory: item.IsDirectory,
            StorageZoneName: item.StorageZoneName,
          }
        })

        const customMenu = sortArray(menuItems, {
          by: ['LinkName'],
          order: 'LinkName',
          customOrders: {
            LinkName: this.theme.assetsMenuOrder,
          },
        })
        this.assetTypes = customMenu
      })
      .catch((error) => {
        console.log('Error fetching folders:')
        console.log(error)
      })
  },
  setup() {
    const { theme } = global

    return {
      theme,
    }
  },
}
</script>
